import React from 'react';
import MediaQuery from 'react-responsive';
import { Parallax } from 'react-parallax';

import './Page.css';

import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

const PageMeetings = props => (
  <div>
    <Navigation navigation={props.navigation} />
    <div id="head">
      <Parallax blur={0} bgImage={props.data.img} bgImageAlt={props.data.title} strength={120}>
        <MediaQuery query="(max-width: 576px)">
          <div style={{ height: '250px' }} />
        </MediaQuery>
        <MediaQuery query="(min-width: 577px) and (max-width: 768px)">
          <div style={{ height: '350px' }} />
        </MediaQuery>
        <MediaQuery query="(min-width: 769px) and (max-width: 991px)">
          <div style={{ height: '450px' }} />
        </MediaQuery>
        <MediaQuery query="(min-width: 992px)">
          <div style={{ height: '600px' }} />
        </MediaQuery>
      </Parallax>
      <div className="container">
        <div className="row">
          <h1 id="title">{props.data.title}</h1>
        </div>
      </div>
    </div>
    <section>
      <div className="container">
        <div className="row" data-init="img-gallery">
          {props.data.meetings.map(({ title, year, img, link }) => (
            <div className="col-md-6 col-lg-4">
              <div className="portfolio-block">
                <a href={`/susret/${year}`}>
                  <img src={img} alt={title} />
                  <h4 className="text-red text-center">{title}</h4>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
    <Footer footer={props.footer} />
  </div>
);
export default PageMeetings;



// WEBPACK FOOTER //
// ./src/components/PageMeetings.js